// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class StringUtils {
  public static isNullOrEmpty(value: string): boolean {
    return value === undefined || value === null || value.trim() === '';
  }
}

export function makeSystemKey(
  matnr: number,
  snr: string,
  modalityid: number
): string {
  return `${matnr}-${snr}-${modalityid}`;
}
